import { ChangeEvent, DataSourceExecutionEvent, DataSourceModeChangeEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutSettlementLeaveHistory } from "./autogen/AutogenLayoutSettlementLeaveHistory";
import { LeaveHistory, LeaveHistoryProps, LeaveHistoryState } from "./LeaveHistory";
import { ModelRow } from "@mcleod/core";

export class SettlementLeaveHistory extends AutogenLayoutSettlementLeaveHistory  implements LeaveHistoryState {
    postMade: boolean;
    balanceRow: ModelRow<any>;

    override onLoad(): void | Promise<void> {
        new LeaveHistory({
            layout: this,
            beforePayeeLookup: (event: LookupModelSearchEvent) => {
                event.filter.non_office_emp = "Y";
                event.filter["drs_payee.type_of"] = "C";
            }
        });
    }


}
